// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.flex[data-v-039c5b43] {\n    display: flex;\n}\n.w-half[data-v-039c5b43] {\n    width: 50%;\n}\n#about[data-v-039c5b43] {\n    max-width: 800px;\n    margin: 3em auto 0 auto;\n    padding: 0 5%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
